module.exports = __webpack_public_path__ + "static/media/2coachHeader.dccb51fa.svg";